import styled from 'styled-components';

const LogoImg = styled.img`
  display: block;
  height: ${({ theme }) => theme.space[3]}px;
  width: auto;
`;

/**
 * Полноразмерный знак istock.info из `public/istock-main.svg` (как в основной системе).
 */
export function IstockMainLogo() {
  return (
    <LogoImg src={`${import.meta.env.BASE_URL}istock-main.svg`} alt="istock.info" decoding="async" />
  );
}
